/**
 * sp mode tap effect changer
 */

var BEFORE_OPACITY = 0.4;
var AFTER_OPACITY = 1;
var BEFORE_COLOR = "#eaeaea";
var AFTER_COLOR = "#fff";

function effectChangeOpacity(element,callback, beforeOpacity, afterOpacity) {
    if ( $(window).width() <= 768) {
        $(element).css('opacity', beforeOpacity);
        setTimeout(() => {
            $(element).css('opacity', afterOpacity);
            if (typeof callback === 'function') {
                callback();
            }
        }, 100);
    }
} 

function effectChangeBackgroundColor(element,callback, beforeColor, afterColor) {
    if ( $(window).width() <= 768) {
        $(element).css('background-color', beforeColor);
        setTimeout(() => {
            $(element).css('background-color', afterColor);
            if (typeof callback === 'function') {
                callback();
            }
        }, 100);
    }
}

module.exports.effectChangeOpacity = effectChangeOpacity;
module.exports.effectChangeBackgroundColor = effectChangeBackgroundColor;
module.exports.BEFORE_OPACITY = BEFORE_OPACITY;
module.exports.AFTER_OPACITY = AFTER_OPACITY;
module.exports.BEFORE_COLOR = BEFORE_COLOR;
module.exports.AFTER_COLOR = AFTER_COLOR;
